<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="6" class="pb-0">
        <v-text-field
          v-model="inputVal.name"
          :label="$t('settings.name')"
          data-cy="name"
          dense
          :rules="config.rules"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="6" class="pb-0">
        <v-text-field
          autocomplete="username"
          v-model="inputVal.email"
          :label="$t('settings.emailTab')"
          data-cy="email"
          dense
          :rules="emailRules"
        ></v-text-field>
      </v-col>
    </v-row>
    <password
      v-if="$route.params.mode === 'new'"
      :value="value"
      :config="config"
    />
    <v-combobox
      v-model="tagNames"
      :search-input.sync="tagSearch"
      :items="tagItems"
      @blur="commitTagSearch"
      :label="$t('accessRoles.tags')"
      multiple
      chips
      small-chips
      deletable-chips
      hide-selected
      dense
      class="mt-4"
    ></v-combobox>
    <div class="mt-6">
      <div class="subtitle-2 mb-2">{{ $t("accessRoles.title") }}</div>
      <accessRolePicker v-model="inputVal.accessRole" />
    </div>
  </div>
</template>
<script>
import password from "./password.vue";
import accessRolePicker from "./accessRolePicker.vue";
import i18n from "../../../i18n";

export default {
  props: ["config", "value"],
  components: { password, accessRolePicker },
  data: () => ({
    tagSearch: "",
    emailRules: [
      (v) => !!v || i18n.t("general.emailRequired"),
      (v) => /.+@.+\..+/.test(v) || i18n.t("general.emailInvalid"),
    ],
    roles: [
      {
        name: i18n.t("employee.accountRoleUser"),
        value: "User",
      },
      { name: i18n.t("employee.accountRoleDriver"), value: "AppUser" },
    ],
  }),
  created() {
    this.$store.dispatch("getAllUserTags");
  },
  methods: {
    commitTagSearch() {
      const text = String(this.tagSearch || "").trim();
      if (!text) return;
      const exists = this.tagNames.some(
        (name) => String(name).toLowerCase() === text.toLowerCase()
      );
      if (!exists) this.tagNames = [...this.tagNames, text];
      this.tagSearch = "";
    },
  },
  computed: {
    tagItems() {
      return this.$store.getters.allUserTags.map((t) => t.tag);
    },
    tagNames: {
      get() {
        return (this.value.tags || []).map((t) => {
          if (t && typeof t === "object") return t.tag;
          const doc = this.$store.getters.allUserTags.find(
            (x) => String(x._id) === String(t)
          );
          return doc ? doc.tag : t;
        });
      },
      set(names) {
        this.$set(this.value, "tags", names);
      },
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
